import useUser from '@alltrails/context/hooks/useUser';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { isTripPlannerAvailable } from '../utils/isTripPlannerAvailable';

const useIsTripPlannerAvailable = () => isTripPlannerAvailable({ languageRegionCode: useLanguageRegionCode(), user: useUser() });

export default useIsTripPlannerAvailable;
